<template>
  <Modal v-model="show" width="430" class="save-as-modal">
    <div slot="header">
      <span>{{ $t("message.workBench.body.script.saveAs.header") }}</span>
    </div>
    <div>
      <Form ref="saveAsForm" :label-width="90">
        <FormItem
          prop="selectedPath"
          :label="
            $t(
              'message.workBench.body.script.saveAs.formItems.selectedPath.label'
            ) + '：'
          "
        >
          <directory-dialog
            :tree="fileTree"
            :load-data-fn="loadDataFn"
            :filter-node="filterNode"
            :path="selectedPath"
            class="save-as-modal-path"
            fs-type="api"
            @set-node="setNode"
          />
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button :loading="isLoading" type="primary" @click="submit">{{
        $t("message.constants.submit")
      }}</Button>
    </div>
  </Modal>
</template>
<script>
import directoryDialog from "@dss/js/component/directoryDialog/index.vue";

export default {
  components: {
    directoryDialog,
  },
  data() {
    return {
      show: false,
      selectedPath: "/",
      fileTree: [],
      loadDataFn: () => {},
      isLoading: false,
      oldPath: "",
      totalFile: [],
      parentId: null,
      fileName: "",
      script:null,
      cb:()=>{}
    };
  },
  methods: {
    async open(script,cb) {
      this.reset();
      this.show = true;
      this.fileName = script.fileName;
      this.script=script;
      this.cb=cb;
      await this.setFileTree();
    },
    filterNode(node) {
      return !node.isLeaf;
    },
    setNode(node) {
      this.parentId = node.id;
      let temp = this.handleUrl(node.id, []);
      this.selectedPath = temp;
    },
    handleUrl(id, list) {
      let temp = this.totalFile.find((item) => {
        return item.id === id;
      });
      if (temp) {
        list.push(temp.name);
        if (temp.parentId) {
          return this.handleUrl(temp.parentId, list);
        }
      }
      return "/" + list.reverse().join("/");
    },
    async setFileTree() {
      this.dispatch("apiSidebar:getTreeList", (tree) => {
        let tmpTree = tree;
        tmpTree = tmpTree.filter((item) => !item.leaf);
        this.totalFile = tmpTree || [];
        let list = this.arrToTree(tmpTree);
        this.fileTree = list;
      });
    },
    arrToTree(arr, id = null) {
      const res = [];
      arr.forEach((item) => {
        item.isLeaf = item.leaf;
        if (item.parentId === id) {
          const children = this.arrToTree(
            arr.filter((v) => v.parentId !== id),
            item.id
          );
          if (children.length) {
            res.push({ ...item, children });
          } else {
            res.push({ ...item });
          }
        }
      });
      return res;
    },
    submit() {
      this.dispatch(
        "Workbench:checkExist",
        { pId: this.parentId,filename:this.script.params.define.name },
        (status) => {
          if (!status) {
            if (!this.isLoading) {
              this.isLoading = true;
            }
            this.dispatch(
              "Workbench:save",
              { pId: this.parentId,script:this.script },
              (status) => {
                this.isLoading = false;
                if (status) {
                  this.show = false;
                  this.cb(true)
                }
              }
            );
          } else {
            this.$Message.warning("该接口名已在此文件夹中存在");
          }
        }
      );
    },
     reset() {
      this.parentId = null;
      this.selectedPath = "/";
    },
   
 
  },
};
</script>
<style lang="scss" src="../index.scss">
</style>
